import { Directive, Input } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { FormObjectComponent } from "../../../shared/forms/form-object.component";

@Directive()
export abstract class EstimateComopnent extends FormObjectComponent {
    @Input() override form: UntypedFormGroup;

    public abstract get total(): number;
    
    public abstract get totalTax(): number;

    public get totalWithTax(): number {
        // console.count('EstimateComopnent.totalWithTax getter called');
        return this.total + this.totalTax;
    }
    
    // Expansion section.
    public isDescriptionOpen: boolean = false;

    public toggleAccordion(): void {
        this.isDescriptionOpen = !this.isDescriptionOpen;
    }
}